import MCompanyAddress from '@/components/invoices/company'
import MInvoiceAddress from '@/components/invoices/address'
import MInvoiceFooter from '@/components/invoices/footer'
export default {
  components: {
    'm-company-address': MCompanyAddress,
    'm-invoice-address': MInvoiceAddress,
    'm-invoice-footer': MInvoiceFooter
  },
  data () {
    return {
      price: {
        admin: 3,
        total: 0
      },
      motives: [
        {text: 'No motive', value: 0},
        {text: 'Radiotherapy', value: 1},
        {text: 'Kinetherapy', value: 2},
        {text: 'Fréquentation', value: 3},
        {text: 'Consultation', value: 4},
        {text: 'Dialysis', value: 5},
        {text: 'Chemotherapy', value: 6},
        {text: 'Shopping', value: 7},
        {text: 'Hospitalisation', value: 8}
      ],
      client: null,
      settings: {},
      credits: []
    }
  },
  methods: {
    calcInvoice () {
      this.price.total = 0;
      this.price.admin = this.factuurType !== 0 ? this.price_admin : 0;
      this.bookings.map((booking) => {
        this.price.total += (booking.price + booking.waitprice + booking.ticket_price);
        if (booking.noMutIntervention) {
          this.price.total -= (booking.mutualPatientAmount || 0);
        }
      })
    },
    calcInvoiceDriver () {
      this.price.total_factuur = this.price.total_cash = this.price.total = this.price.rectification = this.price.commision = 0;
      this.credits = [];
      this.bookings.map((booking) => {
        booking.help4you = this.calcCommission(booking);

        if (booking.factuur || booking.factuurDriver) {
          booking.price_cash = 0;
          booking.price_factuur = (booking.price + booking.waitprice + booking.ticket_price);
        } else {
          booking.price_factuur = 0;
          booking.price_cash = (booking.price + booking.waitprice + booking.ticket_price);
          if (booking.mutualPatientID) {
            booking.price_cash = 0;
            booking.price_factuur = (booking.price + booking.waitprice + booking.ticket_price);
            if (booking.mutualPatientAmount > 0) {
              booking.price_cash += booking.mutualPatientAmount + (booking.waitprice + booking.ticket_price);
              booking.price_factuur -= booking.mutualPatientAmount;
            }
          }
        }

        if (booking.creditDriver) {
          this.credits.push(booking)
          console.log('rectification', booking.creditAmount);
          this.price.rectification += booking.creditAmount
        }

        this.price.total_factuur += booking.price_factuur;
        this.price.total_cash += booking.price_cash;
        this.price.commision += booking.help4you

      })
      this.price.total = this.calcTotal(this.price)
    },
    calcInvoiceInsurance () {
      this.price.total = 0;
      console.log('calcInvoiceInsurance', this.bookings);
      this.bookings.map((booking) => {
        booking.total = booking.mutualAmount || 0;
        if (booking.mutualAmount === 0) {
          booking.total = (Number(booking.mutualDistance) < 11 ? booking.min10km : booking.min10km + (Number(booking.mutualDistance - 10) * booking.plus10km));
        }
        booking.subtotal = booking.total;
        // booking.total = (booking.mutualDistance < 11) ? booking.min10km : booking.plus10km;
        console.log('calcInvoiceInsurance', booking.min10km);
        if (booking.mutualPatientAmount > 0) {
          booking.total -= booking.mutualPatientAmount;
        }
        this.price.total += booking.total;
      })
    },
    calcCommission (price) {
      var total = 0;
      var value = 0;
      value = (price.waitprice) ? (price.price + price.waitprice) : price.price;
      total = ((value / 100) * price.commission);
      return total;
    },
    calcTotal (price) {
      var total = 0
      total = price.rectification ? price.total_factuur + price.rectification : price.total_factuur;
      total = (total - price.commision )
      return total;
    },
    allEqual (array) {
      if (!array.length) return false;
      return array.every(function (element) {
        console.log(element);
        return element.client_id === array[0].client_id;
      });
    },
    getClient (b) {
      console.log('getClient: ', b);
      return this.allEqual(b) ? b[0] : null;
    },
    getSettings () {
      var app = this;
      this.$http
      .get('service/settings')
      .then(response => {
        if (response.data) {
          app.settings = Object.fromEntries(response.data.map(item => [item.variable, item.value]));
        }
        console.log('settings: ', app.settings);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  computed: {
    settings_ () {
      return this.$store.getters.settings;
    }
  },
  filters: {
    formatMotive (v, obj) {
      return obj[v].text;
    }
  }
}
